import { createContext } from 'react';

import { store } from '../../store/index.js';

export const DollhouseContext = createContext(store);
